import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { Workflow } from '@ply-io/ply-front-shared-utilities';
interface TileDropdownButtonStatusProps {
	workflow: Workflow;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TileDropdownButtonStatus',
  props: {
    workflow: null
  },
  setup(__props: any) {

const props = __props as {
	workflow: Workflow;
}


const workflow = computed(() => props.workflow);
const isSetupNotComplete = computed(() => {
	if (workflow.value.installed_from) {
		return !workflow.value.is_setup_completed;
	}
	return false;
});
const isNotPublished = computed(() => !workflow.value.is_published);
const statusMessage = computed(() => {
	if (isNotPublished.value) {
		return 'This is a draft, publish to use this feature.';
	} else if (isSetupNotComplete.value) {
		return 'Setup required';
	}
	return null;
});

return { __sfc: true,props, workflow, isSetupNotComplete, isNotPublished, statusMessage }
}

})